import { useState, useEffect } from 'react';
import { api } from '../../services/api';
import { ChatCenteredText } from '@phosphor-icons/react';
import { toast } from 'sonner';

const STATO_LABELS = {
  ricevuta: 'Ricevuta',
  accettata_da_pagare: 'Accettata',
  confermata_pagata: 'Confermata',
  rifiutata: 'Rifiutata',
  in_attesa: 'Ricevuta',
  confermata: 'Accettata',
};
const STATO_COLORS = {
  ricevuta: 'bg-amber-100 text-amber-800',
  accettata_da_pagare: 'bg-orange-200 text-orange-800',
  confermata_pagata: 'bg-green-100 text-green-800',
  rifiutata: 'bg-red-100 text-red-800',
  in_attesa: 'bg-amber-100 text-amber-800',
  confermata: 'bg-orange-200 text-orange-800',
};

export function InterestNotesSection() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.getBookings().then(res => {
      const withNote = (res.data || []).filter(b => (b.interested_slots_note || '').trim());
      withNote.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
      setRows(withNote);
    }).catch(() => toast.error('Errore caricamento note'))
    .finally(() => setLoading(false));
  }, []);

  const fmt = (d) => { try { return new Date(d).toLocaleString('it-IT', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }); } catch { return ''; } };
  const dayName = (i) => ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'][i] || '';

  return (
    <>
      <div className="mb-6 animate-fade-in">
        <h1 className="text-2xl sm:text-3xl font-bold font-['Work_Sans'] tracking-tight mb-2">Note Interesse Slot</h1>
        <p className="text-[#52525B] text-sm">Note lasciate dai potenziali alunni sugli slot che potrebbero interessare (in attesa di liberarsi).</p>
      </div>

      {loading ? (
        <div className="text-center py-12 text-[#52525B]">Caricamento...</div>
      ) : rows.length === 0 ? (
        <div className="text-center py-12 bg-white border border-[#E4E4E7] rounded-sm">
          <ChatCenteredText size={48} className="mx-auto text-[#E4E4E7] mb-4" />
          <p className="text-[#52525B]">Nessuna nota di interesse ricevuta.</p>
        </div>
      ) : (
        <div className="bg-white border border-[#E4E4E7] rounded-sm overflow-x-auto">
          <table className="w-full text-sm" data-testid="interest-notes-table">
            <thead>
              <tr className="border-b border-[#E4E4E7] bg-[#FAFAFA]">
                <th className="text-left px-3 py-2 text-xs font-semibold uppercase tracking-wider text-[#52525B]">Alunno</th>
                <th className="text-left px-3 py-2 text-xs font-semibold uppercase tracking-wider text-[#52525B]">Email / Tel</th>
                <th className="text-left px-3 py-2 text-xs font-semibold uppercase tracking-wider text-[#52525B]">Insegnante / Slot richiesto</th>
                <th className="text-left px-3 py-2 text-xs font-semibold uppercase tracking-wider text-[#52525B]">Nota</th>
                <th className="text-left px-3 py-2 text-xs font-semibold uppercase tracking-wider text-[#52525B]">Data</th>
                <th className="text-center px-3 py-2 text-xs font-semibold uppercase tracking-wider text-[#52525B]">Stato</th>
              </tr>
            </thead>
            <tbody>
              {rows.map(b => {
                const cs = b.stato === 'in_attesa' ? 'ricevuta' : (b.stato === 'confermata' ? 'accettata_da_pagare' : b.stato);
                return (
                  <tr key={b.id} className="border-b border-[#E4E4E7] hover:bg-[#FAFAFA]" data-testid={`interest-note-row-${b.id}`}>
                    <td className="px-3 py-2 font-semibold uppercase">{b.nome}{b.is_prova && <span className="ml-1 inline-block px-1.5 py-0.5 bg-amber-500 text-white text-[9px] font-extrabold uppercase tracking-wider rounded">PROVA</span>}</td>
                    <td className="px-3 py-2 text-xs text-[#52525B]"><div>{b.email}</div><div>{b.telefono || '-'}</div></td>
                    <td className="px-3 py-2 text-xs"><div className="font-medium">{b.teacher_name}</div><div className="text-[#71717A]">{b.strumento} — {dayName(b.giorno)} {b.ora_inizio} ({b.durata} min)</div></td>
                    <td className="px-3 py-2 text-xs whitespace-pre-wrap max-w-[380px]">{b.interested_slots_note}</td>
                    <td className="px-3 py-2 text-xs text-[#52525B] whitespace-nowrap">{fmt(b.created_at)}</td>
                    <td className="px-3 py-2 text-center"><span className={`text-[10px] font-bold uppercase px-2 py-0.5 rounded ${STATO_COLORS[cs] || 'bg-[#F4F4F5] text-[#52525B]'}`}>{STATO_LABELS[cs] || cs}</span></td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
